export const DEFAULT_REGION = 'DEFAULT';
export const INDIA_REGION = 'IN';

export default async (params) => {
  try {
    const { appType } = params;
    // eslint-disable-next-line no-unused-vars
    let envType = process.env.NODE_ENV;
    if (appType === 'CRA') {
      envType = process.env.REACT_APP_ENVIRONMENT;
    } else if (appType === 'GATSBY') {
      envType = process.env.GATSBY_ENVIRONMENT;
    }

    const region =
      typeof window !== 'undefined' &&
      window &&
      window.cookieStore &&
      (await window.cookieStore.get('ctry'));
    /*
     * Change region here for testing purposes
     */
    if (envType === 'development') {
      // return DEFAULT_REGION;
    }

    /*
     * Except INDIA region all we redirect to US region because we have only two accocunt in the stripe
     */
    if (
      !region ||
      (region.value && region.value.toUpperCase() !== INDIA_REGION)
    ) {
      return DEFAULT_REGION;
    }

    return INDIA_REGION;
  } catch (err) {
    return null;
  }
};
